import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type { Scadenza, CreateScadenzaInput, UpdateScadenzaInput } from '../types';

export function useCreateScadenza() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateScadenzaInput) => api.post<Scadenza>('/scadenze', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useUpdateScadenza() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; projectId: string; data: UpdateScadenzaInput }) =>
      api.patch<Scadenza>(`/scadenze/${id}`, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useDeleteScadenza() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; projectId: string }) => api.delete(`/scadenze/${id}`),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
